import script from "./DropDown.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropDown.vue?vue&type=script&lang=ts&setup=true"

import "./DropDown.vue?vue&type=style&index=0&id=6db6ef23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db6ef23"]])

export default __exports__